/**
 * Shared debounce state for event tooltip hover.
 * ChartContainer schedules the clear; EventTooltip cancels it on mouseEnter.
 */

let _clearTimer: ReturnType<typeof setTimeout> | null = null;
let _clearFn: (() => void) | null = null;

export function registerTooltipClearFn(fn: () => void): void {
  _clearFn = fn;
}

export function scheduleTooltipClear(delayMs = 180): void {
  cancelTooltipClear();
  _clearTimer = setTimeout(() => {
    _clearFn?.();
    _clearTimer = null;
  }, delayMs);
}

export function cancelTooltipClear(): void {
  if (_clearTimer != null) {
    clearTimeout(_clearTimer);
    _clearTimer = null;
  }
}
